<template>
    <span class="inline-select" :class="{ open: dropdownVisible, placeholder: !selectedLabel }">
        <a-dropdown v-model="dropdownVisible" :trigger="['click']">
            <span class="select-trigger" @click="dropdownVisible = !dropdownVisible">
                {{ selectedLabel || placeholder }}
            </span>
            <a-menu slot="overlay" class="inline-select-menu">
                <a-menu-item
                    v-if="searchable"
                    key="search"
                    class="search-item"
                    @click.stop
                >
                    <a-input
                        ref="searchInput"
                        v-model="searchText"
                        placeholder="Ara..."
                        @click.stop
                        prefix="search"
                    />
                </a-menu-item>
                <a-menu-item
                    v-for="option in filteredOptions"
                    :key="option.value"
                    @click="selectOption(option)"
                >
                    <i v-if="option.icon" class="material-icons">{{ option.icon }}</i>
                    {{ option.label }}
                </a-menu-item>
                <a-menu-item v-if="filteredOptions.length === 0" disabled>
                    Sonuç bulunamadı
                </a-menu-item>
            </a-menu>
        </a-dropdown>
    </span>
</template>

<script>
export default {
    name: 'InlineSelect',
    props: {
        value: {
            type: [String, Number, Boolean, Array],
            default: '',
        },
        options: {
            type: Array,
            required: true,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: 'select...',
        },
        searchable: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dropdownVisible: false,
            searchText: '',
        };
    },
    computed: {
        selectedLabel() {
            const option = this.options.find(opt => opt.value === this.value);
            return option ? option.label : '';
        },
        filteredOptions() {
            if (!this.searchText) return this.options;
            const search = this.searchText.toLowerCase();
            return this.options.filter(opt => 
                opt.label.toLowerCase().includes(search)
            );
        },
    },
    methods: {
        selectOption(option) {
            this.$emit('input', option.value);
            this.$emit('change', option.value);
            this.dropdownVisible = false;
            this.searchText = '';
        },
    },
    watch: {
        dropdownVisible(val) {
            if (val && this.searchable) {
                this.$nextTick(() => {
                    if (this.$refs.searchInput) {
                        this.$refs.searchInput.focus();
                    }
                });
            }
        },
    },
};
</script>

<style scoped lang="scss">
.inline-select {
    position: relative;
    display: inline-flex;
    align-items: center;

    .select-trigger {
        font-weight: 600;
        color: #1890ff;
        border-bottom: 2px solid #1890ff;
        padding: 2px 6px;
        cursor: pointer;
        transition: all 0.2s ease;
        display: inline-block;
        min-width: 70px;
        text-align: center;
        white-space: nowrap;
        border-radius: 2px;

        &:hover {
            background: #e6f7ff;
            border-bottom-color: #0050b3;
            transform: translateY(-1px);
        }
    }

    &.placeholder .select-trigger {
        color: #bfbfbf;
        border-bottom-color: #d9d9d9;
        font-style: italic;
        font-weight: 500;
    }

    &.open .select-trigger {
        background: #e6f7ff;
        box-shadow: 0 2px 4px rgba(24, 144, 255, 0.2);
    }
}
</style>

<style lang="scss">
.inline-select-menu {
    max-height: 350px;
    overflow-y: auto;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    border-radius: 6px;

    .search-item {
        padding: 10px 12px;
        cursor: default !important;
        background: #f5f5f5 !important;
        border-bottom: 1px solid #e8e8e8;
        
        &:hover {
            background: #f5f5f5 !important;
        }

        .ant-input-affix-wrapper {
            border: 1px solid #d9d9d9;
            border-radius: 4px;

            &:focus,
            &:focus-within {
                border-color: #1890ff;
                box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
            }
        }
    }

    .ant-menu-item {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px 16px;
        transition: all 0.2s ease;
        border-left: 3px solid transparent;

        .material-icons {
            font-size: 18px;
            color: #999;
            transition: color 0.2s ease;
        }

        &:hover {
            background: #f0f8ff;
            color: #1890ff;
            border-left-color: #1890ff;

            .material-icons {
                color: #1890ff;
            }
        }

        &.ant-menu-item-disabled {
            color: #bfbfbf;
            font-style: italic;
        }
    }
}
</style>

